/* ==========================================================================
   NOE — Scroll Animations & Interactions
   IntersectionObserver-based reveal animations
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Scroll Reveal ---------- */
  function initScrollReveal() {
    var elements = document.querySelectorAll('.noe-reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Parallax Background ---------- */
  function initParallax() {
    var parallaxElements = document.querySelectorAll('[data-noe-parallax]');
    if (!parallaxElements.length) return;

    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset;

      parallaxElements.forEach(function (el) {
        var speed = parseFloat(el.dataset.noeParallax) || 0.3;
        var rect = el.getBoundingClientRect();
        var elementTop = rect.top + scrollY;
        var offset = (scrollY - elementTop) * speed;

        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          el.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
        }
      });

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- Header Scroll State ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    var lastScroll = 0;
    var scrollThreshold = 80;

    window.addEventListener('scroll', function () {
      var currentScroll = window.pageYOffset;

      if (currentScroll > scrollThreshold) {
        header.classList.add('header-wrapper--scrolled');
      } else {
        header.classList.remove('header-wrapper--scrolled');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---------- Image Lazy Load with Fade ---------- */
  function initImageFade() {
    var images = document.querySelectorAll('.noe-img-fade');
    if (!images.length) return;

    images.forEach(function (img) {
      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function () {
          img.classList.add('is-loaded');
        });
      }
    });
  }

  /* ---------- Horizontal Scroll Gallery ---------- */
  function initHorizontalScroll() {
    var galleries = document.querySelectorAll('.noe-hscroll');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      var isDown = false;
      var startX;
      var scrollLeft;

      gallery.addEventListener('mousedown', function (e) {
        isDown = true;
        gallery.classList.add('is-grabbing');
        startX = e.pageX - gallery.offsetLeft;
        scrollLeft = gallery.scrollLeft;
      });

      gallery.addEventListener('mouseleave', function () {
        isDown = false;
        gallery.classList.remove('is-grabbing');
      });

      gallery.addEventListener('mouseup', function () {
        isDown = false;
        gallery.classList.remove('is-grabbing');
      });

      gallery.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - gallery.offsetLeft;
        var walk = (x - startX) * 1.5;
        gallery.scrollLeft = scrollLeft - walk;
      });
    });
  }

  /* ---------- Counter Animation ---------- */
  function initCounterAnimation() {
    var counters = document.querySelectorAll('[data-noe-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach(function (el) {
      observer.observe(el);
    });
  }

  function animateCounter(el) {
    var target = parseInt(el.dataset.noeCounter, 10);
    var duration = 1500;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  /* ---------- Init on DOM Ready ---------- */
  function init() {
    initScrollReveal();
    initParallax();
    initHeaderScroll();
    initImageFade();
    initHorizontalScroll();
    initCounterAnimation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init after Shopify section render (theme editor) */
  document.addEventListener('shopify:section:load', init);
})();
